module.exports = __webpack_public_path__ + "1e846691ea38e26b6722185b16b78bb8.svg";